/* eslint-disable react/destructuring-assignment */
/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable object-shorthand */
/* eslint-disable @typescript-eslint/array-type */
import React, { useEffect, useState } from 'react';
import { Col, Form, InputGroup, Row, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import MaskedInput from 'react-text-mask';
import { customerInputsLength } from '../../../../constants/customerInputsLength';
import { IState } from '../../../../services/state';
import { theme, control } from '../../../../styles/react-select-config';
import { cepMask } from '../../../../utils/masks';
import { normalizeCityName } from '../../../../utils/strings';
import BrasilService from '../../../../services/http/brasil.http';

const CustomerAddress = (props: any) => {
    const [states, setStates] = useState([] as Array<IState>);
    const [cities, setCities] = useState([]);
    const [isDisabled, setDisabled] = useState<boolean>(false);

    const loadCities = async (state: string) => {
        const response = await BrasilService.getCitiesByState(state);

        // eslint-disable-next-line arrow-body-style
        const cities: any[] = response.map((obj) => {
            return {
                label: obj.name,
                value: obj.id,
            };
        });

        cities.unshift({ name: 'Selecione uma cidade', value: '' });

        setCities(cities);
    };

    const getCitiesByState = async (state: string) => {
        const response = await BrasilService.getCitiesByState(state);

        // eslint-disable-next-line arrow-body-style
        const cities: any[] = response.map((obj) => {
            return {
                label: obj.name,
                value: obj.id,
            };
        });

        cities.unshift({ name: 'Selecione uma cidade', value: '' });

        return cities;
    };

    const handleCepChanges = async (event: any) => {
        const value: any = event.target.value;
        const changes = [{ target: { name: 'addressCep', value } }];

        props.handleChanges(changes);

        if (value.replace(/\D/g, '').length === 8) {
            try {
                props.handleLoading(true);

                const data = await BrasilService.getDataByCep(
                    value.replace(/\D/g, ''),
                );

                const state: any = states.find(
                    (item: any) => item.value === data.state,
                );

                const cities = await getCitiesByState(
                    state.value ?? data.state,
                );

                const city: any = cities.find((item: any) => {
                    return (
                        item &&
                        item.label &&
                        normalizeCityName(item.label) ===
                            normalizeCityName(data.city)
                    );
                });

                changes.push({ target: { name: 'erpState', value: state } });
                changes.push({ target: { name: 'erpCity', value: city } });
                changes.push({
                    target: { name: 'erpCityName', value: city.name },
                });
                changes.push({
                    target: {
                        name: 'addressDescription',
                        value: data.street,
                    },
                });
                changes.push({
                    target: {
                        name: 'addressNeighborhood',
                        value: data.neighborhood,
                    },
                });

                setDisabled(true);
            } catch (err) {
                toast.error('CEP Não Localizado');

                changes.push({ target: { name: 'addressCep', value: '' } });
                changes.push({ target: { name: 'erpState', value: {} } });
                changes.push({ target: { name: 'erpCity', value: {} } });
                changes.push({ target: { name: 'erpCityName', value: '' } });
                changes.push({
                    target: { name: 'addressDescription', value: '' },
                });
                changes.push({
                    target: { name: 'addressNeighborhood', value: '' },
                });

                setDisabled(false);
            } finally {
                props.handleLoading(false);
                props.handleChanges(changes);
            }
        }
    };

    useEffect(() => {
        const loadErpStates = async () => {
            const results = await BrasilService.getStates();

            setStates(
                results.map((value) => {
                    return {
                        label: value.nome,
                        value: value.sigla,
                    };
                }),
            );

            if (props.customer.erpState) {
                const uf = props.customer.erpState;
                const cities = await getCitiesByState(uf.value?? '');
                let city: any = cities.find(
                    (item: any) =>
                        normalizeCityName(item.label ?? '') ===
                        normalizeCityName(props?.customer?.erpCityName ?? ''),
                );
                
                if ((city ?? '') .toString() === '' ){
                    city = props?.customer?.erpCityName ?? ''
                }

                props.handleChanges([
                    {
                        target: {
                            name: 'erpState',
                            value: {
                                name: uf?.label,
                                code: uf?.value,
                                label: uf?.label,
                                value: uf?.value,
                            },
                        },
                    },
                    {
                        target: {
                            name: 'erpCity',
                            value:
                                props.customer.erpCity &&
                                props.customer.erpCityName
                                    ? {
                                          label: props.customer.erpCityName,
                                          value: props.customer.erpCity,
                                      }
                                    : {
                                          label: city?.label,
                                          value: city?.value,
                                      },
                        },
                    },
                    { target: { name: 'erpCityName', value: city?.label } },
                ]);
            }
        };

        loadErpStates();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!props.customer.erpState) {
            return;
        }

        loadCities(props.customer.erpState.value);
    }, [props.customer.erpState]);

    const handleStateChanges = async (value: any) => {
        props.handleChanges([
            { target: { name: 'erpState', value: value } },
            { target: { name: 'erpCity', value: null } },
            { target: { name: 'erpCityName', value: null } },
        ]);

        loadCities(value.value);
    };

    const handleCityChanges = async (value: any) => {
        props.handleChanges([
            { target: { name: 'erpCity', value: value } },
            { target: { name: 'erpCityName', value: value.label } },
        ]);
    };

    return (
        <>
            <Form.Group controlId="formBasicCep">
                <Form.Label>CEP</Form.Label>
                <InputGroup>
                    <Form.Control
                        value={props.customer.addressCep}
                        isInvalid={!!props.errors.addressCep}
                        as={MaskedInput}
                        mask={cepMask}
                        onChange={handleCepChanges}
                        name="addressCep"
                        type="text"
                        disabled={props.loadingCep}
                    />
                    {props.loadingCep && (
                        <InputGroup.Text>
                            <Spinner animation="border" size="sm" />
                        </InputGroup.Text>
                    )}
                    {props.errors.addressCep && (
                        <Form.Control.Feedback type="invalid">
                            {props.errors.addressCep}
                        </Form.Control.Feedback>
                    )}
                </InputGroup>
            </Form.Group>

            <Row>
                <Col lg={6} md={12}>
                    <Form.Group controlId="formBasicCep">
                        <Form.Label>Endereço</Form.Label>
                        <Form.Control
                            value={props.customer.addressDescription}
                            isInvalid={!!props.errors.addressDescription}
                            onChange={props.handleChanges}
                            name="addressDescription"
                            type="text"
                            maxLength={40}
                        />
                        {props.errors.addressDescription && (
                            <Form.Control.Feedback type="invalid">
                                {props.errors.addressDescription}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>

                <Col lg={6} md={12}>
                    <Form.Group controlId="formBasicCep">
                        <Form.Label>Número</Form.Label>
                        <Form.Control
                            value={props.customer.addressNumber}
                            isInvalid={!!props.errors.addressNumber}
                            onChange={props.handleChanges}
                            name="addressNumber"
                            type="text"
                            maxLength={customerInputsLength.addressNumber}
                        />
                        {props.errors.addressNumber && (
                            <Form.Control.Feedback type="invalid">
                                {props.errors.addressNumber}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col lg={6} md={12}>
                    <Form.Group controlId="formBasicState">
                        <Form.Label>Estado</Form.Label>
                        <Select
                            placeholder="Selecione..."
                            noOptionsMessage={() => 'Sem opções'}
                            name="erpState"
                            onChange={handleStateChanges}
                            value={props.customer.erpState}
                            options={states}
                            isMulti={false}
                            styles={{ control }}
                            theme={theme}
                            isDisabled={isDisabled}
                        />
                        {props.errors.erpState && (
                            <Form.Control.Feedback type="invalid">
                                {props.errors.erpState}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>
                <Col lg={6} md={12}>
                    <Form.Group controlId="formBasicCity">
                        <Form.Label>Cidade</Form.Label>
                        <Form.Control
                            style={{ display: 'none' }}
                            isInvalid={!!props.errors.erpCity}
                        />
                        <Select
                            placeholder="Selecione..."
                            noOptionsMessage={() => 'Sem opções'}
                            name="erpCity"
                            onChange={handleCityChanges}
                            value={props.customer.erpCity}
                            options={cities}
                            isMulti={false}
                            styles={{ control }}
                            theme={theme}
                            isDisabled={isDisabled}
                        />
                        {props.errors.erpCity && (
                            <Form.Control.Feedback type="invalid">
                                {props.errors.erpCity}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>

                <Col lg={6} md={12}>
                    <Form.Group controlId="formBasicNeighborhood">
                        <Form.Label>Bairro</Form.Label>
                        <Form.Control
                            disabled={props.isDisabled}
                            isInvalid={!!props.errors.addressNeighborhood}
                            onChange={props.handleChanges}
                            value={props.customer.addressNeighborhood}
                            name="addressNeighborhood"
                            maxLength={customerInputsLength.addressNeighborhood}
                            type="text"
                        />
                        {props.errors.addressNeighborhood && (
                            <Form.Control.Feedback type="invalid">
                                {props.errors.addressNeighborhood}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>
                <Col lg={6} md={12}>
                    <Form.Group controlId="formBasicComplement">
                        <Form.Label>Complemento</Form.Label>
                        <Form.Control
                            disabled={props.isDisabled}
                            isInvalid={!!props.errors.addressComplement}
                            onChange={props.handleChanges}
                            value={props.customer.addressComplement}
                            name="addressComplement"
                            maxLength={customerInputsLength.addressComplement}
                            type="text"
                        />
                        {props.errors.addressComplement && (
                            <Form.Control.Feedback type="invalid">
                                {props.errors.addressComplement}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>
            </Row>
        </>
    );
};

export default CustomerAddress;
